import type { ITextConfig } from '../types';

// 脱敏版客户端文案覆盖：仅当构建变量 BUILD_VARIANT=confidential 时启用
// 对应需求：https://tapd.woa.com/tapd_fe/20453857/story/detail/1020453857134949203
export const confidentialTextOverrides: Partial<ITextConfig> = {
  appTitle: '体验测试系统',
  registerHint: '开始注册体验测试系统!',
};
